import HeaderContainer from "./HeaderContainer";
import SaleForm from "../components/SaleForm";
import React from "react";

const SalesContainer = () => {
    return (
        <>
            <HeaderContainer title="Registro de Ventas"></HeaderContainer>
            <div>
                <SaleForm />
            </div>
        </>
    );
}

export default SalesContainer;